// export const ApiUrl = 'http://localhost:5001/backend';
export const ApiUrl = 'https://oneclick.seataxi.in/backend';
// export const ApiUrl = 'https://oneclick-2-o09d.onrender.com/backend';

    